import { useMemo } from 'react';
import { GameMode, ScoreData } from '../lib/types';
import { formatWithCommas } from '../lib/util';
import { MenuButton } from '../MainMenu/mainMenu.styles';
import {
  AverageDecrease,
  AverageIncrease,
  GameOverButtons,
  GameOverContainer,
  GameOverScore,
  GameOverScoreHeader,
  GameOverTable,
  GameOverTitle
} from './game.styles';

type GameOverScreenProps = {
  mode: GameMode;
  score: number;
  level: number;
  longestChain: number;
  scores: ScoreData;
  prevScores: ScoreData;
  restart: () => void;
  exit: () => void;
};

export default function GameOverScreen({
  mode,
  score,
  level,
  longestChain,
  scores,
  prevScores,
  restart,
  exit,
}: GameOverScreenProps) {
  const averageScoreChange = useMemo(() => {
    if (mode === GameMode.Tutorial) return 0;
    return scores[mode].average - prevScores[mode].average;
  }, [mode, prevScores, scores]);

  const renderScoreChange = () => {
    if (averageScoreChange > 0) return <AverageIncrease />;
    if (averageScoreChange < 0) return <AverageDecrease />;
    return null;
  };

  return (
    <GameOverContainer>
      <GameOverTitle>Game Over</GameOverTitle>
      <GameOverScoreHeader>Your Score:</GameOverScoreHeader>
      <GameOverScore>{formatWithCommas(score)}</GameOverScore>
      <GameOverTable>
        <tbody>
        <tr>
          <th>Mode:</th>
          <td>{GameMode[mode]}</td>
        </tr>
        <tr>
          <th>Longest Chain:</th>
          <td>{longestChain}</td>
        </tr>
        <tr>
          <th>Level:</th>
          <td>{level}</td>
        </tr>
        <tr>
          <th>Prev. Avg. Score:</th>
          <td>
            {mode === GameMode.Tutorial
              ? ''
              : formatWithCommas(prevScores[mode].average)}
          </td>
        </tr>
        <tr>
          <th>New Avg. Score:</th>
          <td>
            {mode === GameMode.Tutorial
              ? ''
              : formatWithCommas(scores[mode].average)}
            {renderScoreChange()}
          </td>
        </tr>
        </tbody>
      </GameOverTable>
      <GameOverButtons>
        <MenuButton onClick={restart}>Play Again</MenuButton>
        <MenuButton onClick={exit}>Main Menu</MenuButton>
      </GameOverButtons>
    </GameOverContainer>
  );
}
